var render = function render(){var _vm=this,_c=_vm._self._c;return ((_vm.rows && _vm.rows.length) || (_vm.options.dataset && _vm.options.dataset.length))?_c('e-chart',{style:(_vm.chartStyles),attrs:{"options":_vm.chartOptions,"autoresize":""},on:{"chartInstance":v => _vm.$emit('chartInstance', v)}}):_c('data-empty')
}
var staticRenderFns = []

export { render, staticRenderFns }